import React, { Component } from 'react';
import { View, Scene, AppHeader, Text, Avatar, TimeStamp, Link, FlatList, WebBrowser, TextInput, isWeb, ASButton } from 'core';
import * as actions from 'actions';
import { css, theme, GROUP_ROLES } from 'constants';
import { lang } from 'lang';
import { IcoDownload, IcoDoc } from 'icons';

const styles = css({
  name: {
    color: theme.gray_color,
    fontSize: theme.font_md,
    margin: 10
  },
  search: {
    height: 68,
    borderWidth: 0,
    flex: 1
  },
  row: {
    flexDirection: 'row',
    flex: 1,
    alignItems: 'center',
    paddingLeft: 20,
    borderBottomWidth: theme.hairline,
    borderBottomColor: theme.gray_color_lighten(0.2)
  },
  cell: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    height: 70
  },
  cell_mid: {
    borderRightWidth: isWeb ? theme.hairline : 0,
    borderLeftWidth: isWeb ? theme.hairline : 0,
    borderRightColor: theme.gray_color_lighten(0.2),
    borderLeftColor: theme.gray_color_lighten(0.2)
  },
  cell_left: {
    flex: 1,
    justifyContent: 'flex-start'
  },
  text: {
    color: theme.gray_color
  },
  time: {
    fontSize: theme.font_md,
    textAlign: 'center'
  }
});
class Submissions extends Component {
  componentWillUnmount() {
    const { conv_id, task_id } = this.props;
    actions.sendStopSubmissionWatch({ conv_id, task_id });
  }

  renderTableHeader = () => (
    <View>
      <View style={styles.row}>
        <TextInput style={styles.search} placeholder={lang.SEARCH} />
      </View>
      <View style={styles.row}>
        <View style={[styles.cell, styles.cell_left]}>
          <Text style={styles.text}>{lang.MEMBERS_INFO}</Text>
        </View>
        <View style={[styles.cell, styles.cell_mid, { width: 100 }]}>
          <Text style={styles.text}>{lang.TIME}</Text>
        </View>
        {isWeb ? (
          <View style={[styles.cell, styles.cell_right, { width: 150 }]}>
            <Text style={styles.text}>{lang.SUBMISSION}</Text>
          </View>
        ) : null}
      </View>
    </View>
  );

  renderItem = ({ item }) => {
    const { submissions } = this.props;
    const submission = submissions[item.id];
    const options = [
      {
        icon: IcoDownload,
        text: lang.DOWNLOAD,
        onPress: () => WebBrowser.download(submission)
      },
      {
        icon: IcoDoc,
        text: lang.VIEW,
        onPress: () => WebBrowser.show(submission)
      }
    ];
    if (item.role === GROUP_ROLES.MEMBER || submission) {
      return (
        <View style={styles.row}>
          <View style={[styles.cell, styles.cell_left]}>
            <Avatar data={item} size={32} />
            <Text style={styles.name}>{item.name}</Text>
          </View>
          <View style={[styles.cell, styles.cell_mid, { minWidth: 100 }]}>
            {submission ? (
              <View>
                <TimeStamp value={submission.created} style={styles.time} only_date />
                <TimeStamp value={submission.created} style={styles.time} only_time />
              </View>
            ) : null}
          </View>
          {isWeb ? (
            <View style={[styles.cell, styles.cell_right, { width: 150 }]}>
              {submission ? (
                <Link icon={options[0].icon} onPress={options[0].onPress} style={{ paddingRight: 20 }} color={theme.primary_color} />
              ) : null}
              {submission ? <Link icon={options[1].icon} onPress={options[1].onPress} color={theme.primary_color} /> : null}
            </View>
          ) : submission ? (
            <ASButton options={options} />
          ) : null}
        </View>
      );
    } else {
      return null;
    }
  };

  render() {
    let { members } = this.props;
    return (
      <Scene>
        <AppHeader title={lang.SUBMISSIONS} close />
        <FlatList ListHeaderComponent={this.renderTableHeader} keyExtractor={item => item.id} data={members || []} renderItem={this.renderItem} />
      </Scene>
    );
  }
}

export default Submissions;



// WEBPACK FOOTER //
// ./src/components/modals/submissions.js